// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roles and Permissions Tab Styles */
.roles-permissions-container {
  width: 100%;                       
  margin: 0 auto;
  /* padding: 20px; */
}

/* Tab Header */
.tabs-header {
  display: flex;
  gap: 10px;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab-button {
  padding: 12px 24px;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  cursor: pointer;
  /* font-weight: 500; */
  color: #505050;
  transition: all 0.3s ease;
  position: relative;
  bottom: -2px;
}


.tab-button:hover {
  color: #fafafa;
  background-color: #004996;
  border-radius: 8px 8px 0 0;

}

.tab-button.active {
  color: rgb(253, 253, 253);
  border-bottom-color: #06c;
  font-weight: 600;
  background: #004996;
  border-radius: 8px 8px 0 0;
}
.permissions-header{
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  flex-wrap: wrap;
  align-items: center;

  @media(max-width: 767px) {
    align-items: center;
    justify-content: center;
    gap: 10px;

  }
}

.permissionBtn{
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
/* Tab Content */
.tab-content {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.role-panel h2 {
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}

/* Permissions List */
.permissions-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 15px;
}

.permission-item {
  padding: 12px 16px;
  background: #f9f9f9;
  border-radius: 6px;
  border-left: 4px solid #ddd;
  transition: all 0.2s ease;
}

.permission-item:hover {
  background: #f0f0f0;
  border-left-color: #06c;
}

.permission-label {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
}

.permission-label input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #06c;
}

.permission-name {
  color: #333;
  text-transform: capitalize;
}

.permission-label input[type="checkbox"]:checked ~ .permission-name {
  font-weight: 500;
}

/* Responsive */
@media (max-width: 450px) {
  .tabs-header {
    flex-direction: column;
    gap: 0;
    border-bottom: none;
  }
  
  .tab-button {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid #e0e0e0;
    border-left: 3px solid transparent;
    padding: 14px 20px;
    bottom: 0;
  }
  
  /* .tab-button.active {
    border-bottom-color: #e0e0e0;
    border-left-color: #06c;
    background-color: #f5f9ff;
  } */
  
  .tab-content {
    padding: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/rolesandpermissions.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;;AAE5B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;;EAEnB;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;EAEX;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;AACA,gBAAgB;AAChB;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,MAAM;IACN,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,kCAAkC;IAClC,kBAAkB;IAClB,SAAS;EACX;;EAEA;;;;KAIG;;EAEH;IACE,aAAa;EACf;AACF","sourcesContent":["/* Roles and Permissions Tab Styles */\n.roles-permissions-container {\n  width: 100%;                       \n  margin: 0 auto;\n  /* padding: 20px; */\n}\n\n/* Tab Header */\n.tabs-header {\n  display: flex;\n  gap: 10px;\n  border-bottom: 2px solid #e0e0e0;\n  margin-bottom: 20px;\n}\n\n.tab-button {\n  padding: 12px 24px;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  cursor: pointer;\n  /* font-weight: 500; */\n  color: #505050;\n  transition: all 0.3s ease;\n  position: relative;\n  bottom: -2px;\n}\n\n\n.tab-button:hover {\n  color: #fafafa;\n  background-color: #004996;\n  border-radius: 8px 8px 0 0;\n\n}\n\n.tab-button.active {\n  color: rgb(253, 253, 253);\n  border-bottom-color: #06c;\n  font-weight: 600;\n  background: #004996;\n  border-radius: 8px 8px 0 0;\n}\n.permissions-header{\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  align-items: center;\n\n  @media(max-width: 767px) {\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n  }\n}\n\n.permissionBtn{\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n/* Tab Content */\n.tab-content {\n  padding: 20px;\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.role-panel h2 {\n  color: #333;\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n/* Permissions List */\n.permissions-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 15px;\n}\n\n.permission-item {\n  padding: 12px 16px;\n  background: #f9f9f9;\n  border-radius: 6px;\n  border-left: 4px solid #ddd;\n  transition: all 0.2s ease;\n}\n\n.permission-item:hover {\n  background: #f0f0f0;\n  border-left-color: #06c;\n}\n\n.permission-label {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.permission-label input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  accent-color: #06c;\n}\n\n.permission-name {\n  color: #333;\n  text-transform: capitalize;\n}\n\n.permission-label input[type=\"checkbox\"]:checked ~ .permission-name {\n  font-weight: 500;\n}\n\n/* Responsive */\n@media (max-width: 450px) {\n  .tabs-header {\n    flex-direction: column;\n    gap: 0;\n    border-bottom: none;\n  }\n  \n  .tab-button {\n    width: 100%;\n    text-align: center;\n    border-bottom: 2px solid #e0e0e0;\n    border-left: 3px solid transparent;\n    padding: 14px 20px;\n    bottom: 0;\n  }\n  \n  /* .tab-button.active {\n    border-bottom-color: #e0e0e0;\n    border-left-color: #06c;\n    background-color: #f5f9ff;\n  } */\n  \n  .tab-content {\n    padding: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
